import Markdown from 'markdown-to-jsx';
import React, {ReactElement} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {Alignment} from '../../../types';
import Headers, {HeaderType} from '../Text/Headers/Headers';
import Paragraph, {FontSize, FontWeight} from '../Text/Paragraph/Paragraph';

import './OurProductsInformationBox.scss';

interface Props {
  className?: string;
}

function OurProductsInformationBox({className}: Props): ReactElement {
  const {formatMessage} = useIntl();

  return (
    <div className={`ourProductsInformationBox ${className || ''}`.trim()}>
      <Headers headerType={HeaderType.H3} alignment={Alignment.LEFT}>
        <FormattedMessage id="homepage.ourProducts.links.informationBox.title" />
      </Headers>
      <div className="ourProductsInformationBox__container">
        <div className="ourProductsInformationBox__container__description">
          <Paragraph fontWeight={FontWeight.SEMIBOLD}>
            <FormattedMessage id="homepage.ourProducts.links.informationBox.description.title" />
          </Paragraph>
          <Markdown
            options={{
              overrides: {
                p: {
                  component: Paragraph,
                },
              },
            }}
          >
            {formatMessage({id: 'homepage.ourProducts.links.informationBox.description.markdown'})}
          </Markdown>
        </div>
        <div className="ourProductsInformationBox__container__conditions">
          <div className="ourProductsInformationBox__container__conditions__box">
            <Paragraph fontSize={FontSize.MEDIUM}>
              <FormattedMessage id="homepage.ourProducts.links.informationBox.conditions.box1.title" />
            </Paragraph>
            <Paragraph fontSize={FontSize.MEDIUM}>
              <FormattedMessage id="homepage.ourProducts.links.informationBox.conditions.box1.text" />
            </Paragraph>
          </div>
          <div className="ourProductsInformationBox__container__conditions__box">
            <Paragraph fontSize={FontSize.MEDIUM}>
              <FormattedMessage id="homepage.ourProducts.links.informationBox.conditions.box2.title" />
            </Paragraph>
            <Paragraph fontSize={FontSize.MEDIUM}>
              <FormattedMessage id="homepage.ourProducts.links.informationBox.conditions.box2.text" />
            </Paragraph>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurProductsInformationBox;
